import React, { useRef } from "react";
import { RCCBadge, RCCButton, RCCDropDownItem, RCCGrid, RCCHookToast, RCCIcon, RCCServicesApi, RCCTooltip } from "react-common-components";
import { IForwardPagination } from "react-common-components/dist/components/Pagination/interface";
import OptionsColumn from "src/components/DefaultColumnsList/Options";
import Pagination from "src/components/Pagination";
import Title from "src/components/Title";
import { useConfirmModal } from "src/context/ConfirmModal/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import formatDate from "src/utils/formatDate";
import { IComponentListContractItems, IRefModalAddChangeContractItem } from "./interface";
import ModalAddChangeContractItem from "./modalAddChangeContractItem";

const ListContractItems: React.FC<IComponentListContractItems> = ({
	efa001Id,
	efa002Id,
	dateStart,
	dateEnd
}) => {
	const {translate} = useTranslation();
	const {confirm} = useConfirmModal();
	const {addToast} = RCCHookToast();

	const deleteFunction = (id: number, title: string) => {
		confirm(
			translate("Excluir contrato de empresa"),
			`${translate("Deseja realmente excluir o contrato")} ${title} ?`,
			async () => {
				await RCCServicesApi.deleteRequest({
					method: "BusinessGroup/DeleteContract",
					urlParameters: {
						id
					}
				}); 
	
				addToast({
					color: "green",
					description: translate("Contrato excluído com sucesso"),
					title: translate("Sucesso")
				});

				paginationRef.current?.reload();
			},
			(err) => {
				standardErrorMessages(err, "Erro ao excluir contrato", addToast);
			},
			true
		);
	};

	// List & Pagination
	const paginationRef = useRef<IForwardPagination>(null);
	const modalAddChangeContractItem = useRef<IRefModalAddChangeContractItem>(null);
	const colOptions = (row: any) => (
		  <OptionsColumn>
			<RCCDropDownItem
				selfEnclose
				onClick={() => modalAddChangeContractItem.current?.actionButtonChange(row)}
			>
				<RCCIcon name="pencil" 
				/>
				{translate("Alterar")}
			</RCCDropDownItem>
			<RCCDropDownItem 
				selfEnclose
				onClick={() => deleteFunction(row.efa012Id, row.efa016Descricao)}
			>
				<RCCIcon name="trash" 
				/>
				{translate("Excluir")}
			</RCCDropDownItem>
		  </OptionsColumn>
	);
	const colBloqExceeded = (row: any) => (
		<RCCBadge color={row.efa012Bloqexcedido === "N" ? "green" : "red"}
			styleInline="font-size: 0.83rem;"
		>
			{row.efa012Bloqexcedido === "N" ? translate("Permite") : translate("Bloqueia")}
		</RCCBadge>
	);
	const colTitle = (row: any) => (
		<RCCGrid container item direction="column">
			<Title color="defaultColor" size="xs">
				{row.efa016Descricao}
			</Title>
			<Title color="grey" size="xs">
				{row.efa012Comentario}
			</Title>
		</RCCGrid>
	);
    
	return (
		<>
			<RCCGrid container item direction="column">
				<RCCGrid container item alignItems="center" justifyContent="flex-end">
					<RCCTooltip
						text={translate("Adicionar item do contrato")}
						color="purple"
					>
						<RCCButton 
							color="purple"
							icon={{
								name: "plus"
							}}
							layout="isRounded"
							size="md"
							onClick={() => modalAddChangeContractItem.current?.actionButtonAdd()}
						/>
					</RCCTooltip>
				</RCCGrid>
				<Pagination 
					ref={paginationRef}
					dataOrRoute="BusinessGroup/ListContracts"
					filtersData={{
						efa001Id,
						efa002Id: efa002Id ?? "",
						date: formatDate(dateStart)
					}}     
					columns={[
						{
							idColumn: "efa012Tipo",
							nameColumn: translate("Tipo"),
							xs: 12,
							sm: 8,
							cellRenderer: colTitle
						},
						{
							idColumn: "efa012Valor",
							nameColumn: translate("Valor"),
							xs: 2,
							sm: 1,
							type: "number"
						},
						{
							idColumn: "efa012Bloqexcedido",
							nameColumn: translate("Bloquear excedente"),
							xs: 12,
							sm: 2,
							cellRenderer: colBloqExceeded
						},
						{
							idColumn: "options",
							nameColumn: " ",
							justify: "right",
							xs: 12,
							sm: 1,
							cellRenderer: colOptions,
							disableSort: true
						}
					]}
				/>
			</RCCGrid>
			<ModalAddChangeContractItem 
				ref={modalAddChangeContractItem}
				paginationRef={paginationRef}
				efa001Id={efa001Id}
				efa002Id={efa002Id}
				dateStart={dateStart}
				dateEnd={dateEnd}
			/>
		</>
	);
};

export default ListContractItems;
